type SyncUrlManagerOptions = {
  replace?: boolean
}

export function syncUrlManagerBuilder() {
  let params = new URLSearchParams(globalThis.location.search)
  const defaultOptions = { replace: true }

  return {
    params,
    setParams(newParams: Record<string, string>) {
      params = new URLSearchParams()

      for (const [key, value] of Object.entries(newParams)) {
        if (!value) {
          params.delete(key)
          continue
        }

        params.set(key, value)
      }
    },

    syncUrl(opts?: SyncUrlManagerOptions) {
      const options = opts ?? defaultOptions
      const pathname = globalThis.location.pathname
      const url = params.size === 0 ? `${pathname}` : `${pathname}?${params}`

      if (options.replace) {
        globalThis.history.replaceState({}, '', url)
      } else {
        globalThis.history.pushState({}, '', url)
      }
    },
  }
}
